import { useState } from "react";
import { Link } from "react-router";
import BrandLogo from "./BrandLogo";
import { BRAND } from "../constants/config";
import { trackEvent } from "../services/analytics";

const DEFAULT_NAV_ITEMS = [
  { id: "pourquoi", label: "Avantages" },
  { id: "comment", label: "Comment ça marche ?" },
  { id: "faq", label: "FAQ" },
  { id: "inscrire", label: "S'inscrire" },
];

export default function Navbar({
  variant = "default",
  alternateLink,
  onScrollTo,
  navItems = DEFAULT_NAV_ITEMS,
  ctaLabel,
  onCtaClick,
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const gradientClass =
    variant === "entreprise"
      ? "from-brand-primaryDark to-brand-accent2"
      : "from-brand-primary to-brand-secondary";

  const handleNavClick = (sectionId) => {
    onScrollTo?.(sectionId);
    setIsMenuOpen(false);
  };

  const handleCtaClick = () => {
    trackEvent("cta_click", { location: "navbar", variant });
    onCtaClick?.();
    setIsMenuOpen(false);
  };

  const ctaButtonClass =
    variant === "entreprise"
      ? "bg-white text-brand-primaryDark hover:bg-gray-100"
      : "bg-white text-brand-primary hover:bg-gray-100";

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 bg-gradient-to-r ${gradientClass} bg-opacity-95 backdrop-blur shadow-sm`}
    >
      <div className="container mx-auto px-4 py-3 md:py-4">
        <div className="md:hidden grid grid-cols-[1fr_auto_1fr] items-center">
          <BrandLogo className="h-9 justify-self-start" />
          <span className="text-lg font-bold text-white tracking-tight text-center">
            {BRAND.name}
          </span>
          <button
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="justify-self-end text-white focus:outline-none p-2"
            aria-label="Menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        <div className="hidden md:flex justify-between items-center">
          <BrandLogo />

          <div className="flex items-center gap-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => handleNavClick(item.id)}
                className="text-sm font-semibold text-white hover:text-white/80 transition px-2 py-1"
              >
                {item.label}
              </button>
            ))}
            {alternateLink && (
              <Link
                to={alternateLink.to}
                className="text-sm font-semibold text-white/80 hover:text-white border border-white/30 rounded-full px-3 py-1 transition"
              >
                {alternateLink.label}
              </Link>
            )}
            {ctaLabel && onCtaClick && (
              <button
                type="button"
                onClick={handleCtaClick}
                className={`text-sm font-semibold px-4 py-2 rounded-full transition shadow-md ${ctaButtonClass}`}
              >
                {ctaLabel}
              </button>
            )}
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-white/20">
            <div className="flex flex-col space-y-2 pt-4">
              {ctaLabel && onCtaClick && (
                <button
                  type="button"
                  onClick={handleCtaClick}
                  className={`font-semibold px-4 py-3 rounded-full transition text-center ${ctaButtonClass}`}
                >
                  {ctaLabel}
                </button>
              )}
              {navItems.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => handleNavClick(item.id)}
                  className="text-white hover:text-white/80 transition text-left px-2 py-2 text-sm font-semibold"
                >
                  {item.label}
                </button>
              ))}
              {alternateLink && (
                <Link
                  to={alternateLink.to}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-white/80 hover:text-white transition text-left px-2 py-2 text-sm font-semibold"
                >
                  {alternateLink.label}
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
